export default __webpack_public_path__ + "static/media/confirmed-image.2395583a.png";